import { portableTextWithInternalLinks } from '../../utils/portableText'

export const productImageOrVideoPerColorBlock = `
_type == 'productsImageOrVideoPerColor' => {
  images[] {
    ...,
    _type == "img" => {
      image {
        ...,
        image-> {
          _type,
          _id,
          path,
          dimensions
        }
      }
    }
  },
  "ksp": ksp[_key == $lang][0].value,
  "btn_label": btn_label[_key == $lang][0].value,
  "content": content[_key == $lang][0].value[] {
    ${portableTextWithInternalLinks}
  },
}
`
